import { UserRole } from "../models/User";

export interface UserPermissionariesSource {
	permissionariesIds?: string[];
	permissionaryId?: string;
	permissionaryRoles?: {
		permissionaryId: string;
		role: UserRole;
	}[];
	role?: UserRole;
}

export function getUserPermissionariesIds(
	source?: UserPermissionariesSource | null
): string[] {
	if (!source) {
		return [];
	}

	if (Array.isArray(source.permissionariesIds)) {
		return source.permissionariesIds.filter(Boolean);
	}

	return source.permissionaryId ? [source.permissionaryId] : [];
}

export function getUserRoleForPermissionary(
	source: UserPermissionariesSource | null | undefined,
	permissionaryId: string
): UserRole {
	if (!source) {
		return UserRole.USER;
	}

	return (
		source.permissionaryRoles?.find(
			(permissionaryRole) =>
				permissionaryRole.permissionaryId === permissionaryId
		)?.role ||
		source.role ||
		UserRole.USER
	);
}

export function getAdminPermissionaryIds(
	source: UserPermissionariesSource | null | undefined
): string[] {
	return getUserPermissionariesIds(source).filter(
		(permissionaryId) =>
			getUserRoleForPermissionary(source, permissionaryId) === UserRole.ADMIN ||
			getUserRoleForPermissionary(source, permissionaryId) === UserRole.GOD
	);
}
